/* horizonscroller.js: handle left/right scrolling buttons */

import $ from 'jquery';

var checkChevronTimeout = 500;
var checkChevronTimer;

export function init() {
	$('body').on('click', '.horizon-scroll-left', function(event) {
		var button = $(this);
		var horizon = button.parents('.row-horizon');

		var to = horizon.scrollLeft() - horizon.children().last().width();
		horizon.animate({
             scrollLeft: to
        }, 300);
	});
	$('body').on('click', '.horizon-scroll-right', function(event) {
		var button = $(this);
		var horizon = button.parents('.row-horizon');

		var to = horizon.scrollLeft() + horizon.children().last().width();
		horizon.animate({
             scrollLeft: to
        }, 300);
	});

	initCheckChevronTimer();
}

function showHideChevrons(target) {
	var scrollY = target.scrollLeft();
	var rowWidth = target[0].scrollWidth - target.width();

	if(scrollY === 0) {
		target.find('.horizon-scroll-left').fadeOut('fast');
	}
	else {
		target.find('.horizon-scroll-left').fadeIn('fast');
	}

	if(scrollY === rowWidth) {
		target.find('.horizon-scroll-right').fadeOut('fast');
	}
	else {
		target.find('.horizon-scroll-right').fadeIn('fast');
	}
}

function checkChevron() {
	$('body .row-horizon').each(function() {
		showHideChevrons($(this));
	});
}

function initCheckChevronTimer() {
	checkChevron();
	checkChevronTimer = window.setInterval(checkChevron, checkChevronTimeout);
}



//////////////////
// WEBPACK FOOTER
// ./public/js/~/horizonscroller.js
// module id = 3
// module chunks = 0